// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__25fpM","block":"Loader_block__1Uh7A","value":"Loader_value__URcOA"};